import { z } from 'zod'

import { apiClient } from '@/utils/axios.ts'

const AutomationServiceSchema = z.object({
  serviceType: z.string(),
  runBehavior: z.string(),
  fromTime: z
    .string()
    .nullish()
    .optional()
    .transform((time) => (time ? new Date('1970-01-01T' + time + 'Z') : null)),
  toTime: z
    .string()
    .nullish()
    .optional()
    .transform((time) => (time ? new Date('1970-01-01T' + time + 'Z') : null)),
})

export const ListAutomationSettingsResponseSchema = z.array(
  AutomationServiceSchema,
)

export type AutomationService = z.infer<typeof AutomationServiceSchema>

export type AutomationSettingsList = z.infer<
  typeof ListAutomationSettingsResponseSchema
>

const list = (creatorId: number) => {
  return apiClient
    .get(`/settings/automation/${creatorId}`)
    .then((response) =>
      ListAutomationSettingsResponseSchema.parse(response.data),
    )
}

const update = (
  creatorId: number,
  data: {
    serviceType: string
    runBehavior: string
    fromTime?: string
    toTime?: string
  },
) => {
  return apiClient.post(`/settings/automation/${creatorId}`, data)
}

export const automationSettingsService = { list, update }
